import request from '@/system/engine/request';
import config from '@/system/engine/config';
import {getLocalStorage} from '@/system/store/localstorage';

export function btcAjaxTable(limit,pagination,id,created_at,code,master_id,from_master_id,to_master_id,transaction_type,total_amount){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'coin/BTC/ajaxTable?language='+language+'&limit=' + limit  + '&pagination=' + pagination + '&id=' + id + '&created_at=' + created_at + '&code=' + code + '&master_id=' + master_id + '&from_master_id=' + from_master_id + '&to_master_id=' + to_master_id + '&transaction_type=' + transaction_type + '&total_amount=' + total_amount,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function btcInfo(id){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'coin/BTC/info?language='+language+'&id=' + id,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function bchabcAjaxTable(limit,pagination,id,created_at,code,master_id,from_master_id,to_master_id,transaction_type,total_amount){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'coin/BCHABC/ajaxTable?language='+language+'&limit=' + limit  + '&pagination=' + pagination + '&id=' + id + '&created_at=' + created_at + '&code=' + code + '&master_id=' + master_id + '&from_master_id=' + from_master_id + '&to_master_id=' + to_master_id + '&transaction_type=' + transaction_type + '&total_amount=' + total_amount,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function bchabcInfo(id){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'coin/BCHABC/info?language='+language+'&id=' + id,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function ethAjaxTable(limit,pagination,id,created_at,code,master_id,from_master_id,to_master_id,transaction_type,total_amount){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'coin/ETH/ajaxTable?language='+language+'&limit=' + limit  + '&pagination=' + pagination + '&id=' + id + '&created_at=' + created_at + '&code=' + code + '&master_id=' + master_id + '&from_master_id=' + from_master_id + '&to_master_id=' + to_master_id + '&transaction_type=' + transaction_type + '&total_amount=' + total_amount,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function ethInfo(id){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'coin/ETH/info?language='+language+'&id=' + id,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function ltcAjaxTable(limit,pagination,id,created_at,code,master_id,from_master_id,to_master_id,transaction_type,total_amount){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'coin/LTC/ajaxTable?language='+language+'&limit=' + limit  + '&pagination=' + pagination + '&id=' + id + '&created_at=' + created_at + '&code=' + code + '&master_id=' + master_id + '&from_master_id=' + from_master_id + '&to_master_id=' + to_master_id + '&transaction_type=' + transaction_type + '&total_amount=' + total_amount,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function ltcInfo(id){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'coin/LTC/info?language='+language+'&id=' + id,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function dogeAjaxTable(limit,pagination,id,created_at,code,master_id,from_master_id,to_master_id,transaction_type,total_amount){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'coin/DOGE/ajaxTable?language='+language+'&limit=' + limit  + '&pagination=' + pagination + '&id=' + id + '&created_at=' + created_at + '&code=' + code + '&master_id=' + master_id + '&from_master_id=' + from_master_id + '&to_master_id=' + to_master_id + '&transaction_type=' + transaction_type + '&total_amount=' + total_amount,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function dogeInfo(id){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'coin/DOGE/info?language='+language+'&id=' + id,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function dashAjaxTable(limit,pagination,id,created_at,code,master_id,from_master_id,to_master_id,transaction_type,total_amount){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'coin/DASH/ajaxTable?language='+language+'&limit=' + limit  + '&pagination=' + pagination + '&id=' + id + '&created_at=' + created_at + '&code=' + code + '&master_id=' + master_id + '&from_master_id=' + from_master_id + '&to_master_id=' + to_master_id + '&transaction_type=' + transaction_type + '&total_amount=' + total_amount,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function dashInfo(id){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'coin/DASH/info?language='+language+'&id=' + id,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function usdtAjaxTable(limit,pagination,id,created_at,code,master_id,from_master_id,to_master_id,transaction_type,total_amount){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'coin/USDT/ajaxTable?language='+language+'&limit=' + limit  + '&pagination=' + pagination + '&id=' + id + '&created_at=' + created_at + '&code=' + code + '&master_id=' + master_id + '&from_master_id=' + from_master_id + '&to_master_id=' + to_master_id + '&transaction_type=' + transaction_type + '&total_amount=' + total_amount,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function usdtInfo(id){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'coin/USDT/info?language='+language+'&id=' + id,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function gcaAjaxTable(limit,pagination,id,created_at,code,master_id,from_master_id,to_master_id,transaction_type,total_amount){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'coin/GCA/ajaxTable?language='+language+'&limit=' + limit  + '&pagination=' + pagination + '&id=' + id + '&created_at=' + created_at + '&code=' + code + '&master_id=' + master_id + '&from_master_id=' + from_master_id + '&to_master_id=' + to_master_id + '&transaction_type=' + transaction_type + '&total_amount=' + total_amount,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function gcaInfo(id){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'coin/GCA/info?language='+language+'&id=' + id,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function migrateAjaxTable(limit,pagination,id,created_at,code,master_id,from_master_id,to_master_id,transaction_type,total_amount){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'coin/HOPEZ/ajaxTable?language='+language+'&limit=' + limit  + '&pagination=' + pagination + '&id=' + id + '&created_at=' + created_at + '&code=' + code + '&master_id=' + master_id + '&from_master_id=' + from_master_id + '&to_master_id=' + to_master_id + '&transaction_type=' + transaction_type + '&total_amount=' + total_amount,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function gcaMigrate(id){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'coin/HOPEZ/info?language='+language+'&id=' + id,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function gratisAjaxTable(limit,pagination,id,created_at,code,master_id,from_master_id,to_master_id,transaction_type,total_amount){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'coin/GRATIS/ajaxTable?language='+language+'&limit=' + limit  + '&pagination=' + pagination + '&id=' + id + '&created_at=' + created_at + '&code=' + code + '&master_id=' + master_id + '&from_master_id=' + from_master_id + '&to_master_id=' + to_master_id + '&transaction_type=' + transaction_type + '&total_amount=' + total_amount,
		method: 'get'
	});

	return Promise.resolve(data);
}

export function gratisInfo(id){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'coin/GRATIS/info?language='+language+'&id=' + id,
		method: 'get'
	});

	return Promise.resolve(data);
}